<template>
    <div class="com-search-input-box" v-bind:class="className">
        <div class="com-search-input">
            <i class="iconfont icon-search com-i-s"></i>
            <!-- v-to-focus-search-input='true' -->
            <input v-bind:id="inputId" class="com-si-input" type="text" v-model="searchData.searchText" placeholder="搜索" @input="inputSearch" @focus="focusSearch" @blur="blurSearch" >
        </div>
        <div v-if="showFake" class="search-fake-div" @click="clickSearchInput"></div>
    </div>
</template> 

<script>
export default {
    name: 'SearchInput',
    props: ['className', 'inputId', 'searchData', 'inputFunc', 'focusFunc', 'blurFunc'],
    directives : {
        "to-focus-search-input" : function (el, binding) {
            if(binding.value){
                setTimeout(() => { el.focus() }, 300);
            }
        }
    },
    data() {
        return {
            showFake: true
        }
    },
    methods:{
        inputSearch() {
            if(this.inputFunc && typeof(this.inputFunc) == 'function'){
                this.inputFunc(this.searchData.searchText);
            }
        },
        focusSearch() {
            this.showFake = false;
            if(this.focusFunc && typeof(this.focusFunc) == 'function'){
                this.focusFunc();
            }
        },
        blurSearch() {
            this.showFake = true;
            if(this.blurFunc && typeof(this.blurFunc) == 'function'){
                this.blurFunc();
            }
        },
        clickSearchInput() {
            var inputNode = document.getElementById(this.inputId);
            if(inputNode) {
                inputNode.focus();
            }
        },
    }
}
</script>